import { ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarModule, ClickEventArgs, ToolbarAllModule, MenuModule, MenuItemModel, MenuEventArgs } from '@syncfusion/ej2-angular-navigations';
import { ToolbarButton, ToolbarOverflowMode, ToolbarItemType } from '@itm/types';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { ButtonAllModule, SwitchModule } from '@syncfusion/ej2-angular-buttons';
import { DropDownButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import { MatIconModule } from '@angular/material/icon';
import { BreadcrumbsComponent } from '@itm/components/breadcrumbs'
import { LayoutService } from '@itm/services';
import { TooltipModule } from '@syncfusion/ej2-angular-popups'

@Component({
  selector: 'itm-toolbar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
  // encapsulation: ViewEncapsulation.None,
  imports: [CommonModule,
    MatIconModule,
    ToolbarModule,
    TooltipModule,
    DropDownListModule,
    ToolbarAllModule,
    MenuModule,
    ButtonAllModule,
    DropDownButtonModule,
    BreadcrumbsComponent,
    SwitchModule,
  ]
})
export class ItmToolbarComponent {
  public itmToolbarAction: any = { 'class': 'itm-toolbar-action' };

  ///constants
  TOOL_BAR_ITEM_TYPE_BUTTON: ToolbarItemType = 'Button';
  TOOL_BAR_ITEM_TYPE_SWITCH: ToolbarItemType = 'Switch';
  TOOL_BAR_ITEM_TYPE_SEPARATOR: ToolbarItemType = 'Separator';
  TOOL_BAR_ITEM_TYPE_DROPDOWN_BUTTON: ToolbarItemType = 'DropdownButton';
  TOOL_BAR_TYPE_FORM: string = 'form';
  TOOL_BAR_TYPE_LIST: string = 'list';

  ///inputs
  breadcrumb = input<string[]>();
  overflowMode = input<ToolbarOverflowMode>();
  toolbarType = input.required<string>();
  buttons = input.required<ToolbarButton[]>();
  editTitle = input<string>();
  buttonsSorted = computed(() => {
    // console.log(this.buttons())
    return this.buttons().sort((a, b) => {
      // Handle null or undefined values
      if (a.order == null && b.order == null) return 0; // Both are null or undefined
      if (a.order == null) return -1; // a is null or undefined, comes before b
      if (b.order == null) return 1; // b is null or undefined, comes before a

      // Compare numeric orders
      return a.order - b.order;
    });
  });

  mobileMenus = computed(() => {
    return [{
      text: '',
      iconCss: 'custom-icon-three-dots',
      items: this.buttonsSorted()?.filter((f: any) => f.visibleOnMobile==true).map((m: any) => {
        return {
          text: m.caption,
          id: m.name,
          iconCss: m.prefixIcon
        }
      })
    }]
  });

  private readonly _ls = inject(LayoutService);

  constructor(){
    effect(() =>{
      // console.log(this.mobileMenus())
    });
  }

  ngOnInit(): void {
  }

  onMenuItemClick(args: MenuEventArgs): void {
    // console.log('Clicked:', args.item, args.item.id);
    const buttonText = args?.item?.id;
    if (buttonText != '') {
      this._ls.setToolbarButtonClick(buttonText);
    }
  }

  public toolbarClick(args: ClickEventArgs): void { 
    const buttonText = args?.item?.id;
    if (buttonText != '') {
      this._ls.setToolbarButtonClick(buttonText);
    }
  }

  public toolbarFormClick(args: ClickEventArgs): void {
    const buttonText = args.item.text;
    if (buttonText != '') {
      this._ls.setToolbarFormButtonClick(buttonText);
    }
  }

  onExportClick(args: any) {
    const exportType = args.element.innerText;
    if (exportType != '') {
      this._ls.setToolbarButtonClick(exportType);
    }
  }

  switchState: boolean = true;
  onSwitchChange(name: any, event: any): void {
    this.switchState = event.checked;
    this.buttons().map((m: any) => {
      if(['DoNotEscalate', 'Remind', 'Archive', 'Export'].includes(m.name))
        m.visible = this.switchState;
    });
    this._ls.setToolbarSwitchClick({name, checked: this.switchState});
    // Handle the switch state as needed
  }

//  public menuItems: MenuItemModel[] = [
//         {
//             text: '',
//             iconCss: 'em-icons e-file',
//             items: [
//                 { text: 'Open', iconCss: 'e-icons e-open' },
//                 { text: 'Save', iconCss: 'e-icons e-save' },
//                 { separator: true },
//                 { text: 'Exit' }
//             ]
//         }
//     ];

}
